/*
  Fabrix Home: özel bölümlerden sepete ekleme (Horizon 4.2 sözleşmesi, assets/product-form.js #processBatchAddToCart ile aynı akış).
  Kullanım:
    import { addLines } from '@theme/fabrix-cart';   // ya da window.FabrixCart.addLines
    await addLines([{ id: 123, quantity: 1 }], 'fabrix-set-builder');
  Sepet sayacı ve çekmece CartLinesUpdateEvent ile güncellenir; ekleme sonrası çekmece açılır.
*/
import { CartLinesUpdateEvent } from '@shopify/events';

function cartSectionIds() {
  return [...document.querySelectorAll('cart-items-component')]
    .map((el) => el instanceof HTMLElement && el.dataset.sectionId)
    .filter(Boolean);
}

export function openCart() {
  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (drawer && typeof drawer.open === 'function') return drawer.open();
  if (window.Shopify?.actions?.openCart) return window.Shopify.actions.openCart();
  window.location.href = Theme.routes.cart_url;
}

export async function addLines(lines, source = 'fabrix', { open = true } = {}) {
  const items = lines.filter((l) => l && l.id).map((l) => ({ id: Number(l.id), quantity: Number(l.quantity) || 1 }));
  if (!items.length) return null;
  const total = items.reduce((s, i) => s + i.quantity, 0);
  const deferred = CartLinesUpdateEvent.createPromise();

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
      promise: deferred.promise,
    })
  );

  const refresh = async () => (await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })).json();

  try {
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: cartSectionIds().join(',') }),
    });
    const data = await res.json();
    const cart = await refresh();
    if (data.status) {
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { didError: true, items: cart.items, source, sourceId: source, itemCount: total },
      });
      throw new Error(data.description || data.message || 'Sepete eklenemedi');
    }
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source, sourceId: source, itemCount: total, sections: data.sections, didError: false },
    });
    if (open) openCart();
    return cart;
  } catch (err) {
    deferred.reject(err);
    throw err;
  }
}

window.FabrixCart = { addLines, openCart };
